import React, {useEffect} from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Avatar, Grid, Box } from "@material-ui/core";
import Typed from "react-typed";
import avatar from "../avatar.png";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//  CSS STYLES
const useStyles = makeStyles(theme => ({
  avatar: {
    width: theme.spacing(20),
    height: theme.spacing(20),
    margin: theme.spacing(1)
  },
  title: {
    color: "#e67410"
  },
  subtitle: {
    color: "tan",
    marginBottom: "3rem"
  },
  typedContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100vw",
    textAlign: "center",
    zIndex: 1
  }
}));

const Header = () => {

  useEffect(() => {
    toast("Keep your device in it's default orientation for best experience");
    },[]);

  // using the css defined
  const classes = useStyles();
  return (
    <Box className={classes.typedContainer}>
      <Grid container justify="center">
        <Avatar className={classes.avatar} src={avatar} alt="Ankit Rana" />
      </Grid>
      <Typography className={classes.title} variant="h4">
        <Typed strings={["Ankit Rana..."]} typeSpeed={100} />
      </Typography>
      <br />
      <Typography className={classes.subtitle} variant="h5">
        <Typed
          strings={["Frontend Developer","Web Designer", "Blogger", "Public Speaker", "Technology Enthusiast" ]}
          typeSpeed={60}
          backSpeed={40}
          loop
        />
      </Typography>
    </Box>
  );
};

export default Header;
